import { useState, useRef, useCallback } from "react";
import { IoClose } from "react-icons/io5";

import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import { v4 } from "uuid";

import apiBackoffice from "../../../../../services/apiBackoffice";
import { useAuth } from "../../../../../hooks/auth";

import Input from "../../../../../components/Atoms/Input";
import Loading from "../../../../../components/Atoms/Loading";
import Button from "../../../../../components/Atoms/Button";
import ImageUploadV2, {
  ImageUploadHanldes,
} from "../../../../../components/Atoms/ImageUploadV2";

import { BannersAdmin } from "../../../../../models/BannersModels";

import * as S from "./styles";

interface AddBannerTypes {
  onClose: () => void;
  refreshFeth: () => void;
}

const initialInputValues: BannersAdmin = {
  schoolid: "",
  bannerid: "",
  title: "",
  description: "",
  url_base64: "",
  type: "",
  linkurl: "",
  position: "",
};

const AddBanner: React.FC<AddBannerTypes> = ({ onClose, refreshFeth }) => {
  const [loading, setIsLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState("");
  const [inputValues, setInputValues] = useState(initialInputValues);
  const { user } = useAuth();
  const formRef = useRef<FormHandles>(null);
  const imageRef = useRef<ImageUploadHanldes>(null);

  const handleInputChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleChangeImg = (img: string): void => {
    setImgUrl(img);
  };

  const handleSubmit = useCallback(
    async (data: BannersAdmin) => {
      if (loading) return;

      if (imgUrl === "") {
        window.alert("Por favor, selecione uma imagem!");

        return;
      }

      setIsLoading(true);
      try {
        const generatedId = v4();

        const saveBody = {
          userid: user.userid,
          bannerid: generatedId,
          position: Number(data.position) || 1,
          linkurl: data.linkurl?.trim() || " ",
          url_base64: imgUrl,
          schoolid: user.schoolid,
          type: " ",
          description: " ",
          title: " ",
        };

        const response = await apiBackoffice.post<any>(
          "backoffice/banner/add",
          saveBody
        );

        // A Lambda responde vazio quando recusa o corpo: só "OK" confirma a gravação.
        if (response.data !== "OK") {
          throw new Error(
            response.data?.errorMessage ||
              response.data?.message ||
              "O servidor não confirmou a gravação. O banner não foi salvo."
          );
        }

        window.alert("Banner Salvo!");
        setInputValues(initialInputValues);
        setImgUrl("");
        imageRef.current?.reset();
        onClose();
        refreshFeth();
      } catch (err: any) {
        window.alert(
          `Erro ao salvar o banner: ${
            err?.response?.data?.message ||
            err?.message ||
            "tente novamente."
          }`
        );
      } finally {
        setIsLoading(false);
      }
    },
    [user, user?.userid, imgUrl, loading]
  );

  return (
    <S.Container>
      <S.CloseModalButton onClick={onClose}>
        <IoClose color="grey" size={32} />
      </S.CloseModalButton>
      <S.HeaderContainer>
        <S.Title> Novo Banner </S.Title>
      </S.HeaderContainer>

      {/* O formulário fica montado durante o envio para não perder a imagem escolhida se der erro. */}
      <S.Row>
        <ImageUploadV2
          ref={imageRef}
          type="simple"
          setImg={handleChangeImg}
          customChild={false}
          bannerStyle={true}
        />
      </S.Row>
      <S.Row>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          className="form big"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
          autoComplete="off"
        >
          <Input
            name="linkurl"
            placeholder="Link"
            value={inputValues.linkurl}
            onChange={(e) => handleInputChanges(e)}
          />
          <Input
            name="position"
            placeholder="Posição"
            value={inputValues.position}
            onChange={(e) => handleInputChanges(e)}
          />
          <div style={{ paddingBottom: "60px" }}>
            <Button type="submit" disabled={loading}>
              {loading ? <Loading size={2} /> : "Salvar"}
            </Button>
          </div>
        </Form>
      </S.Row>
    </S.Container>
  );
};

export default AddBanner;
